import React from "react";
import { Link } from "react-router-dom";
import { HeartPulse, ArrowRight } from "lucide-react";
import PageTitle from "../components/PageTitle";
import { services } from "../data/mock";

export default function Expertise() {
  return (
    <div>
      <PageTitle title="Expertise" crumbs={[{ label: "Expertise" }]} />
      <section className="py-20 px-4 bg-[#fbf6ee]">
        <div className="max-w-7xl mx-auto text-center mb-12">
          <p className="font-script text-emerald-700 text-2xl mb-2">Expertise?</p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900">We Provide Best Cardiac Services</h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <span className="h-[3px] w-10 bg-amber-400"></span>
            <HeartPulse className="w-5 h-5 text-[#b81d24]" />
            <span className="h-[3px] w-10 bg-amber-400"></span>
          </div>
        </div>
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12 pt-6">
          {services.map((s) => (
            <Link
              to={`/services/${s.slug}`}
              key={s.slug}
              className="group relative bg-[#b81d24] text-white rounded-2xl p-7 pt-14 hover:bg-[#9a1820] transition-colors shadow-md hover:shadow-2xl hover:-translate-y-1 duration-300"
            >
              <div className="absolute -top-7 left-1/2 -translate-x-1/2 w-14 h-14 rounded-full bg-amber-400 flex items-center justify-center shadow-md">
                <HeartPulse className="w-7 h-7 text-[#1a1a1a]" />
              </div>
              <h3 className="text-xl font-bold text-center mb-3">{s.title}</h3>
              <div className="w-12 h-[3px] bg-amber-400 mx-auto mb-4" />
              <p className="text-white/85 text-sm text-center min-h-[80px]">{s.short}</p>
              <div className="mt-5 flex justify-center">
                <span className="w-10 h-10 rounded-full border border-white/50 flex items-center justify-center group-hover:bg-amber-400 group-hover:border-amber-400 group-hover:text-[#1a1a1a] transition-colors">
                  <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
